import { UAParser } from 'ua-parser-js'

export interface PlatformInfo {
	deviceType: 'mobile' | 'tablet' | 'desktop'
	os: string
	browser: string
}

export function detectPlatform(): PlatformInfo {
	const parser = new UAParser()
	const device = parser.getDevice()
	const os = parser.getOS()
	const browser = parser.getBrowser()

	const deviceType = device.type === 'mobile' ? 'mobile'
		: device.type === 'tablet' ? 'tablet'
		: 'desktop'

	return {
		deviceType,
		os: os.name ?? '',
		browser: browser.name ?? '',
	}
}
